export default {
  confirmDelete: {
    header: 'Parameter "{parameter}" von "{asset}" löschen?',
    message: 'Stattdessen gilt der Wert der nächsthöheren Anlage oder, falls keine ihn definiert, der Standardwert.',
  },
};
